export class TipoEventoTracking {
    codigo: number;
    descricao: string;
    quantidade: number;
}